import configdata from "../../config.json";
import { moldSliceAction } from "./MoldSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";

export const getAllMoldItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi("get", `${configdata.SERVER_URL}/api/molds`);
    
    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(moldSliceAction.getAllMold(res.data.molds));
  };
};
export const createMoldItem = (data) => {
  return async (dispatch) => {
    const { form } = getOnlyValueFromSelectObject(data);
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/molds/store`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          moldSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      moldSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(moldSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setIsSuccess(true));

    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllMoldItems());
  };
};
export const getDataForEdit = (id, productList) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/molds/edit/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.molds[0] };

    const product = productList.find((item) => {
      return item.value === data.product_id;
    });

    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };

    data.product = {
      value: product.value,
      label: product.label,
      type: product.type,
    };

    dispatch(moldSliceAction.getMoldDataEdit(data));
  };
};

export const updateMoldItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/molds/update/${data.id}`,
      form
    );
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          moldSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      moldSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(moldSliceAction.setInitialData());
    dispatch(appLevelSliceActions.setIsSuccess(true));

    dispatch(appLevelSliceActions.setLoadingState());
    dispatch(getAllMoldItems());
  };
};

export const deleteMoldItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi("get", `${configdata.SERVER_URL}/api/molds/delete/${id}`);
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
